import React, {useEffect} from "react";
import { TextField } from "@mui/material";
import { ArrowBackIosNew } from "@mui/icons-material";
import { GridSaveAltIcon } from "@mui/x-data-grid";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Modal, Grid, Stack, Typography, ModalClose, Sheet } from "@mui/joy";
import { Experimental_CssVarsProvider as CssVarsProvider } from "@mui/material/styles";
import IWorkContact from "../../../types/work-contact.type";

interface ModalProps {
  isOpen: boolean,
  onSubmit: (data: IWorkContact) => void,
  onClose: () => void,
  workContact: IWorkContact | undefined,
  readOnly?: boolean;
}

const WorkContactModal: React.FC<ModalProps> = (props) => {
  const { isOpen, onClose, onSubmit, workContact, readOnly = false} = props;

  const initialValues: IWorkContact = {
    id: workContact?.id,
    email: "",
    firstName: "",
    lastName: "",
    principalPhone: "",
    secondaryPhone: ""
  };

  const validationSchema = Yup.object({
    firstName: Yup.string().required('El Nombre es requerido'),
    lastName: Yup.string().required('El Apellido es requerido')
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validationSchema,
  });

  useEffect(() => {
    if (isOpen && workContact?.id) {
      formik.setValues(workContact);
    } else {
      formik.resetForm()
    }
  }, [isOpen]);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Sheet
        variant="outlined"
        sx={{
          width: 730,
          borderRadius: 'md',
          p: 3,
          boxShadow: 'lg',
          maxHeight: 700,
          // overflow: "scroll"
        }}
      >
        <ModalClose variant="plain" sx={{ m: 1 }} />
        <Typography level="h4" component="h1" sx={{ paddingLeft: 1 }}>
          {workContact?.id ? "Editar Contacto de Obra" : "Nuevo Contacto de Obra"}
        </Typography>
        <form className="form" onSubmit={formik.handleSubmit}>
          <Grid
            container
            rowSpacing={2}
            columnSpacing={2}
            marginBlock={1}
            marginInline={0}
            sx={{ width: '100%' }}
          >
            <Grid xl={12} md={12} sm={12} xs={12}>
              <CssVarsProvider>
                <TextField
                  fullWidth
                  id="firstName"
                  label="Nombre"
                  name="firstName"
                  variant="filled"
                  type={"text"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.firstName}
                  error={!!(formik.touched.firstName && formik.errors.firstName)}
                  slotProps={{ inputLabel: {shrink: true}, input: {readOnly: readOnly}}}
                />
                {formik.touched.firstName && formik.errors.firstName ? (
                  <span className="Error-alert">{formik.errors.firstName}</span>
                ) : null}
              </CssVarsProvider>
            </Grid>

            <Grid xl={12} md={12} sm={12} xs={12}>
              <CssVarsProvider>
                <TextField
                  fullWidth
                  id="lastName"
                  label="Apellido"
                  name="lastName"
                  variant="filled"
                  type={"text"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.lastName}
                  error={!!(formik.touched.lastName && formik.errors.lastName)}
                  slotProps={{ inputLabel: {shrink: true}, input: {readOnly: readOnly}}}
                />
                {formik.touched.lastName && formik.errors.lastName ? (
                  <span className="Error-alert">{formik.errors.lastName}</span>
                ) : null}
              </CssVarsProvider>
            </Grid>

            <Grid xl={12} md={12} sm={12} xs={12}>
              <CssVarsProvider>
                <TextField
                  fullWidth
                  id="email"
                  label="Email"
                  name="email"
                  variant="filled"
                  type={"email"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                  error={!!(formik.touched.email && formik.errors.email)}
                  slotProps={{ inputLabel: {shrink: true}, input: {readOnly: readOnly}}}
                />
              </CssVarsProvider>
            </Grid>

            <Grid xl={12} md={12} sm={12} xs={12}>
              <CssVarsProvider>
                <TextField
                  fullWidth
                  id="principalPhone"
                  label="Telefono Principal"
                  name="principalPhone"
                  variant="filled"
                  type={"text"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.principalPhone}
                  error={!!(formik.touched.principalPhone && formik.errors.principalPhone)}
                  slotProps={{ inputLabel: {shrink: true}, input: {readOnly: readOnly}}}
                />
              </CssVarsProvider>
            </Grid>

            <Grid xl={12} md={12} sm={12} xs={12}>
              <CssVarsProvider>
                <TextField
                  fullWidth
                  id="secondaryPhone"
                  label="Telefono Secundario"
                  name="secondaryPhone"
                  variant="filled"
                  type={"text"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.secondaryPhone}
                  error={!!(formik.touched.secondaryPhone && formik.errors.secondaryPhone)}
                  slotProps={{ inputLabel: {shrink: true}, input: {readOnly: readOnly}}}
                />
              </CssVarsProvider>
            </Grid>

          </Grid>
          <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{paddingRight: 1}}>
            <Button variant="outlined" endDecorator={<ArrowBackIosNew />} onClick={onClose}>Cerrar</Button>
            {!readOnly &&
              <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon />}>Guardar</Button>
            }
          </Stack>
        </form>
      </Sheet>
    </Modal>
  );
};

export default WorkContactModal;
